
import { defineComponent, PropType } from "vue";
import { default as CommonLabel } from "@/components/Common/Label.vue";
import { useI18n } from "vue-i18n";
import { Game } from "@/store/state";
import { SectionColors } from "..";

export default defineComponent({
  props: {
    label: {
      type: undefined as unknown as PropType<string>,
      required: false,
    },
    type: String,
    game: {
      type: Object as PropType<Game>,
      required: false,
    },
  },
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "global",
    });

    return { t };
  },
  components: {
    CommonLabel,
  },
  data() {
    return {
      staffPick: "staff\npick",
      mainColor: SectionColors.GamesMainColor,
      secondaryColor: SectionColors.GamesSecondaryColor,
    };
  },
  computed: {
    cssProps(): unknown {
      return {
        "--games-main-color": this.$data.mainColor,
        "--games-secondary-color": this.$data.secondaryColor,
      };
    },
  },
});
